import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function ShiftEntry (props) {
  const departmentName = useValue('department_name', null)
  const employmentType = useValue('employment_type')

  return (
    <a
      className='entry schedule'
      title={`Planlagt vagt: ${departmentName}, ${employmentType}`}
      style={props.position}
    />
  )
}
